// Module
var code = `<customer-breadcrumbs></customer-breadcrumbs>
<customer-profile-header></customer-profile-header>
<section class="box">
    <div class="info info--deposit">
      <div class="info-detail">
        <span class="key">Account number</span>
        <span class="value">{{\$ctrl.account.productNumber}}</span>
      </div>
    </div>

    <h2 class="section-header">Automatic balance sweep configuration</h2>

    <form name="form">
      <table class="misc-transaction__table table table--generate-row-ids">
        <thead>
        <th></th>
        <th>Property</th>
        <th>Current state</th>
        <th>Target state</th>
        </thead>
        <tbody>

        <tr>
          <td></td>
          <td>Enabled</td>
          <td>{{\$ctrl.currentSweep.enabled | prettyBoolean}}</td>
          <td>
            <select
              ng-model="\$ctrl.sweepInput.enabled"
              boolean-options>
            </select>
          </td>
        </tr>
        <tr ng-if="\$ctrl.sweepInput.enabled">
          <td></td>
          <td>Sweep interval (minutes)</td>
          <td>{{\$ctrl.currentSweep.sweepInterval || '-'}}</td>
          <td>
            <select
              ng-required="\$ctrl.sweepInput.enabled"
              ng-disabled="!\$ctrl.sweepInput.enabled"
              ng-model="\$ctrl.sweepInput.sweepInterval"
              ng-options="entry.value as entry.label for entry in \$ctrl.intervalOptions">
              <option value="">-- Select interval --</option>
            </select>
          </td>
        </tr>
        <tr ng-if="\$ctrl.sweepInput.enabled">
          <td></td>
          <td>Target product number</td>
          <td>{{\$ctrl.currentTargetDisplay || '-'}}</td>
          <td>
            <div style="position: relative;">
              <!-- MASKED product number -->
              <input ng-if="\$ctrl.productNumberMask"
                type="text"
                ng-disabled="!\$ctrl.sweepInput.enabled"
                ng-model="\$ctrl.targetProductNumberInput"
                ng-model-options="{ debounce: 300 }"
                ng-change="\$ctrl.searchTarget()"
                ui-mask="{{\$ctrl.productNumberMask}}"
                ui-options="{clearOnBlur: false}"
                model-view-value="true"
                autocomplete="off">
              <!-- NON-MASKED product number -->
              <input ng-if="!\$ctrl.productNumberMask"
                type="text"
                ng-disabled="!\$ctrl.sweepInput.enabled"
                ng-model="\$ctrl.targetProductNumberInput"
                ng-model-options="{ debounce: 300 }"
                ng-change="\$ctrl.searchTarget()"
                autocomplete="off">
              <ul class="dropdown-menu" style="display: block; position: absolute; width: 100%; max-height: 200px; overflow-y: auto;" ng-if="\$ctrl.targetResults.length > 0">
                <li ng-repeat="result in \$ctrl.targetResults">
                  <a ng-click="\$ctrl.selectTarget(result)" style="cursor: pointer;">
                    {{result.productNumber}} - {{result.customerName}}
                  </a>
                </li>
              </ul>
              <div ng-if="\$ctrl.targetError" style="margin-top: 4px;">
                <span class="text-danger">{{\$ctrl.targetError}}</span>
              </div>
            </div>
          </td>
        </tr>
        <tr ng-if="\$ctrl.sweepInput.enabled">
          <td></td>
          <td>Retain maintaining balance</td>
          <td>{{\$ctrl.currentSweep.retainMaintainingBalance | prettyBoolean}}</td>
          <td>
            <select
              ng-disabled="!\$ctrl.sweepInput.enabled"
              ng-model="\$ctrl.sweepInput.retainMaintainingBalance"
              boolean-options>
            </select>
          </td>
        </tr>

        </tbody>
      </table>

      <div class="clearfix"></div>

      <div class="buttons">
        <button class="btn btn-warning" ng-click="\$ctrl.redirectBack()">Cancel</button>
        <button class="btn btn-primary" ng-click="\$ctrl.update()" ng-disabled="form.\$invalid || (\$ctrl.sweepInput.enabled && !\$ctrl.sweepInput.targetId)">
          Update
        </button>
      </div>

    </form>
</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/accounts/edit-sweep/edit-account-sweep.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;